export var DepositMethodType;
(function (DepositMethodType) {
    DepositMethodType["ONLINE"] = "online";
    DepositMethodType["ONLINE_MANUAL"] = "online_manual";
    DepositMethodType["SCAN_WECHAT"] = "scan_wechat";
    DepositMethodType["SCAN_ALIPAY"] = "scan_alipay";
    DepositMethodType["GOUBAO"] = "goubao";
    DepositMethodType["TOPAY"] = "topay";
    DepositMethodType["EBPAY"] = "ebpay";
    DepositMethodType["UNION_PAY_QUICK"] = "union_pay_quick";
    DepositMethodType["UNION_PAY_CLOUD"] = "union_pay_cloud";
    // 虛擬幣轉帳
    DepositMethodType["CRYPTO_ERC"] = "erc20";
    DepositMethodType["CRYPTO_TRC"] = "trc20";
    // 人工存款
    DepositMethodType["MANUAL"] = "manual";
    DepositMethodType["MANUAL_DEPOSIT"] = "manual_deposit";
    DepositMethodType["MANUAL_EVENT"] = "manual_event";
    DepositMethodType["MANUAL_OTHER"] = "manual_other";
    DepositMethodType["MANUAL_RISK_ADJUSTMENT"] = "manual_risk_adjustment";
    DepositMethodType["CGPAY"] = "cgpay";
    DepositMethodType["CGPAY_USDT"] = "cgpay_usdt";
    DepositMethodType["KOIPAY"] = "koipay";
    DepositMethodType["E_CNY"] = "e_cny";
    DepositMethodType["PAY988"] = "pay988";
    DepositMethodType["PAY808"] = "pay808";
    DepositMethodType["KDPAY"] = "kdpay";
})(DepositMethodType || (DepositMethodType = {}));
//# sourceMappingURL=DepositMethodType.js.map